import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import Seo from "../components/Seo";

export default function AdminLoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("mee_token", data.access_token);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-surface border border-border px-4 py-3 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none transition-colors";

  return (
    <div data-testid="admin-login-page" className="grid-bg grain min-h-[85vh] flex items-center justify-center px-5">
      <Seo title="Admin Login" robots="noindex, nofollow" />
      <form onSubmit={submit} className="w-full max-w-sm border border-border bg-surface/60 p-8">
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center border border-primary/50"><Lock className="h-4 w-4 text-primary" /></span>
          <div>
            <p className="mono-label">Admin</p>
            <h1 className="font-display text-lg">My Eco Engineer</h1>
          </div>
        </div>
        <div className="mt-8 space-y-4">
          <input data-testid="admin-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={field} />
          <input data-testid="admin-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={field} />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-3 text-xs text-destructive">{error}</p>}
        <button data-testid="admin-login-submit" disabled={loading}
          className="mt-6 w-full bg-primary text-primary-foreground font-medium text-sm py-3 hover:bg-primary-hover transition-colors disabled:opacity-60">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
